import { combineReducers, configureStore } from '@reduxjs/toolkit';

import { setupListeners } from '@reduxjs/toolkit/query';
import bluetoothClasicProbeSlice from '../features/bluetoothClassic.slice';
import deviceSlice from '../features/device.slice';
import wifiProbeSlice from '../features/wifiProbe.slice';
import DeviceApiService from '../provider/redux/query/device.service';
import ProbeApiService from '../provider/redux/query/probe.service';

const appReducer = combineReducers({
  [ProbeApiService.reducerPath]: ProbeApiService.reducer,
  [DeviceApiService.reducerPath]: DeviceApiService.reducer,

  wifiProbes: wifiProbeSlice.reducer,
  bluetoothClassicProbes: bluetoothClasicProbeSlice.reducer,
  devices: deviceSlice.reducer,
});
const rootReducer = (state, action) => {
  // if (action.type === 'userAuth/logOut') {
  //   return appReducer(undefined, action);
  // }
  return appReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer,
  devTools: process.env.NODE_ENV !== 'production',
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(ProbeApiService.middleware, DeviceApiService.middleware),
});

setupListeners(store.dispatch);
export default store;
